import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { RelatedPartyEntityIndex } from '@funnels/types';

import { TextInputField } from '../../../Fields';

interface ContactCompanyNameProps extends RelatedPartyEntityIndex {
  label?: string;
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const ContactCompanyName = ({ relatedPartyIndex, isOptional, isDisabled, label }: ContactCompanyNameProps) => (
  <TextInputField
    label={label || 'Company name'}
    name={FIELD_PATHS.RELATED_PARTY_BUSINESS_NAME(relatedPartyIndex)}
    isOptional={isOptional}
    isDisabled={isDisabled}
    className={PII_FIELD_MASKING_CLASS}
  />
);
